import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'


export const initialState = {
    prospect: null,
    fetching: false,
    error: null,
    hasChanged: false,
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [type.FIND_PROSPECT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_PROSPECT_SUCCESS]: (state, action) => {
        const { prospect } = action.payload
        return {
            ...state,
            prospect,
            fetching: false,
        }
    },
    [type.FIND_PROSPECT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_PROSPECT]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            hasChanged: true,
            prospect: {
                ...state.prospect,
                [name]: value,
            },
        }
    },
    [type.SAVE_PROSPECT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_PROSPECT_SUCCESS]: (state, action) => {
        const { prospect } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: false,
            prospect,
        }
    },
    [type.SAVE_PROSPECT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.NO_SHOW_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.NO_SHOW_SUCCESS]: (state, action) => {
        const { prospect } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: false,
            prospect,
        }
    },
    [type.NO_SHOW_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.START_IN_SHOP_PROCESS_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.START_IN_SHOP_PROCESS_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.START_IN_SHOP_PROCESS_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.ARCHIVE_PROSPECT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.ARCHIVE_PROSPECT_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.ARCHIVE_PROSPECT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/prospect/state/detail/reducer.js